import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
export default class SolvedFilter extends Component {
  view() {
    if (!this.shouldShowFilter()) return null;
    const selected = app.discussions.bestAnswer;
    const options = ['all', 'solved', 'unsolved'];
    return Dropdown.component({
      buttonClassName: 'Button',
      label: app.translator.trans("fof-best-answer.forum.filter.".concat(options[Number(selected)] || Object.keys(options).map(key => options[Number(key)])[0], "_label")),
      accessibleToggleLabel: app.translator.trans('fof-best-answer.forum.filter.accessible_label')
    }, Object.keys(options).map(value => {
      const label = options[Number(value)];
      const active = (selected || Object.keys(options)[0]) === value;
      return Button.component({
        icon: active ? 'fas fa-check' : true,
        active: active,
        onclick: () => {
          app.discussions.bestAnswer = value;
          if (value === '0') {
            delete app.discussions.bestAnswer;
          }
          this.reloadDiscussions();
        }
      }, app.translator.trans("fof-best-answer.forum.filter.".concat(label, "_label")));
    }));
  }
  reloadDiscussions() {
    app.discussions.refresh();
  }
  shouldShowFilter() {
    var _currentTag$isQnA;
    const _this$attrs = this.attrs,
      currentTag = _this$attrs.currentTag,
      alwaysShow = _this$attrs.alwaysShow;
    if (alwaysShow) return true;
    if (!app.forum.attribute('showBestAnswerFilterUi')) return false;
    return !!(currentTag != null && (_currentTag$isQnA = currentTag.isQnA) != null && _currentTag$isQnA.call(currentTag));
  }
}
flarum.reg.add('fof-best-answer', 'forum/components/SolvedFilter', SolvedFilter);